import React, { ReactNode } from "react";

interface props {
  children?: ReactNode;
  className?: string;
}

export default function AlertWrapper({ children, className }: props) {
  const validChildren = React.Children.toArray(children).filter((child) => Boolean(child));

  if (validChildren.length > 0) {
    return <div className={`mb-4 flex flex-col gap-px ${className ?? ""}`}>{children}</div>;
  }
  return <></>;
}
